"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const info = {
    100: '#EDF5FF',
    200: '#C6E0FE',
    300: '#9DCAFE',
    400: '#74B4FE',
    500: '#4B9EFF',
    600: '#3A80CF',
    700: '#2B629F',
    800: '#1D4570',
    900: '#102740'
};
exports.default = info;
